import { render, staticRenderFns } from "./EvalProfiles.vue?vue&type=template&id=b796f2ec&scoped=true"
import script from "./EvalProfiles.vue?vue&type=script&lang=js"
export * from "./EvalProfiles.vue?vue&type=script&lang=js"
import style0 from "./EvalProfiles.vue?vue&type=style&index=0&id=b796f2ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b796f2ec",
  null
  
)

export default component.exports